import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

const StatusModel = (props) => {
  const closePopup = () => {
    props.hide();
  };

  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval" style={{width:"600px"}}>
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                  <div className="bookcampaign">
                    {(!props.handleSubmit ||props.code !== 200) &&
                    <div>
                      <img
                        src="../../assets/images/tick.png"
                        className="saved_camp"
                      />
                    </div>}
                    <div className="success_camp_created">
                      <p>{props.message} {!props.handleSubmit && "!"}</p>
                      
                    </div>
                    {props.handleSubmit && (
                      <div className="confirn-btn" style={{marginTop:"50px"}}>
                        <button className="cancel-reqst" onClick={props.hide}>
                          CANCEL
                        </button>
                        <button
                          className="confirm-reqst"
                          onClick={props.handleSubmit}
                        >
                          PROCEED
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default StatusModel;



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/statusupdate.js